import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40959d5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search__tracks-courses" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Resultados por trilhas")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Não há nenhum comentário por aqui", -1))
const _hoisted_4 = { class: "courses-list" }
const _hoisted_5 = { class: "courses" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchHeader = _resolveComponent("SearchHeader")!
  const _component_ModalIntroductoryContent = _resolveComponent("ModalIntroductoryContent")!
  const _component_Comment = _resolveComponent("Comment")!
  const _component_content_fallback = _resolveComponent("content-fallback")!
  const _component_CommentsModal = _resolveComponent("CommentsModal")!
  const _component_course = _resolveComponent("course")!
  const _component_PaginationDefault = _resolveComponent("PaginationDefault")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SearchHeader, null, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    (_ctx.openModalIntroductoryContent && _ctx.course.introductoryContent)
      ? (_openBlock(), _createBlock(_component_ModalIntroductoryContent, {
          key: 0,
          onClose: _ctx.closeModalIntroductoryContent,
          "introductory-content": _ctx.course.introductoryContent
        }, null, 8, ["onClose", "introductory-content"]))
      : _createCommentVNode("", true),
    (_ctx.isCommentsModalOpen)
      ? (_openBlock(), _createBlock(_component_CommentsModal, {
          key: 1,
          onCloseCommentsModal: _ctx.closeCommentsModal,
          title: _ctx.commentModalTitle
        }, {
          default: _withCtx(() => [
            (_ctx.comments.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.comments, (comment, index) => {
                  return (_openBlock(), _createBlock(_component_Comment, {
                    key: index,
                    "user-name": comment.userName,
                    comment: comment.message,
                    date: _ctx.toLocaleDateTime(comment.createAt),
                    stars: comment.rating,
                    "user-image": comment.userImage,
                    "content-name": comment.contentName
                  }, null, 8, ["user-name", "comment", "date", "stars", "user-image", "content-name"]))
                }), 128))
              : (_openBlock(), _createBlock(_component_content_fallback, { key: 1 }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["onCloseCommentsModal", "title"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
          return (_openBlock(), _createBlock(_component_course, {
            key: course.id,
            course: course,
            blocked: _ctx.isCardBlocked(course),
            onLoadCourseCommentsModal: ($event: any) => (_ctx.loadCourseCommentsModal(course)),
            onOpenIntroductoryContent: ($event: any) => (_ctx.openIntroductoryContent(course)),
            onOpenCourse: ($event: any) => (
            _ctx.$router.push({ name: 'course', params: { course_id: course.id } })
          )
          }, null, 8, ["course", "blocked", "onLoadCourseCommentsModal", "onOpenIntroductoryContent", "onOpenCourse"]))
        }), 128))
      ]),
      (_ctx.coursesPage)
        ? (_openBlock(), _createBlock(_component_PaginationDefault, {
            key: 0,
            "qt-pages": _ctx.coursesPage,
            currentPage: Number(_ctx.$route.query.page) || 1,
            onChangePage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateQuery(_ctx.$router, 'page', $event)))
          }, null, 8, ["qt-pages", "currentPage"]))
        : _createCommentVNode("", true)
    ])
  ]))
}